import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [searchParams] = useSearchParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(name, email, password);
      toast.success("Account created");
      const planId = searchParams.get("plan");
      if (planId) {
        nav(`/pricing?plan=${planId}`);
      } else {
        nav("/app/whatsapp");
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not register");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[var(--sw-bg)]">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="register-form">
        <div className="mb-6 flex items-center gap-2">
          <div className="w-7 h-7 rounded-sm bg-slate-900 grid place-items-center">
            <Sparkles size={16} className="text-white" />
          </div>
          <div className="font-heading font-semibold">Brainydo</div>
        </div>
        <div className="label-eyebrow mb-2">Get Started</div>
        <h2 className="font-heading text-3xl font-semibold tracking-tight">Create your workspace.</h2>
        <p className="text-slate-600 mt-2 text-[14px]">Set up Brainydo in under a minute.</p>

        <div className="mt-8 space-y-4">
          <div>
            <label className="label-eyebrow">Name</label>
            <input
              required value={name} onChange={(e) => setName(e.target.value)}
              className="mt-1.5 w-full h-10 px-3 border border-slate-200 rounded-sm bg-white outline-none focus:border-slate-900 text-[14px]"
              data-testid="register-name-input"
              placeholder="Your name"
            />
          </div>
          <div>
            <label className="label-eyebrow">Email</label>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 w-full h-10 px-3 border border-slate-200 rounded-sm bg-white outline-none focus:border-slate-900 text-[14px]"
              data-testid="register-email-input"
              placeholder="you@company.com"
            />
          </div>
          <div>
            <label className="label-eyebrow">Password</label>
            <input
              type="password" required minLength={6}
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 w-full h-10 px-3 border border-slate-200 rounded-sm bg-white outline-none focus:border-slate-900 text-[14px]"
              data-testid="register-password-input"
              placeholder="At least 6 characters"
            />
          </div>
          <button
            type="submit" disabled={busy}
            className="w-full h-10 bg-slate-900 hover:bg-slate-800 text-white font-medium text-[14px] rounded-sm disabled:opacity-60"
            data-testid="register-submit-btn"
          >
            {busy ? "Creating…" : "Create account"}
          </button>
          <p className="text-[13px] text-slate-600 pt-2">
            Already have an account?{" "}
            <Link to="/login" className="text-slate-900 underline underline-offset-2" data-testid="link-login">
              Sign in
            </Link>
          </p>
        </div>
      </form>
    </div>
  );
}
